var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout-container flex-center layout-backtop"},[_c('Header'),_c('Main'),_c('el-backtop',{attrs:{"target":".layout-backtop .el-main .el-scrollbar__wrap"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }